import { __extends } from "tslib";
import { deserializeAws_restJson1_1DeleteSessionCommand, serializeAws_restJson1_1DeleteSessionCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteSessionCommand = /** @class */ (function (_super) {
    __extends(DeleteSessionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteSessionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteSessionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteSessionCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1DeleteSessionCommand(input, context);
    };
    DeleteSessionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1DeleteSessionCommand(output, context);
    };
    return DeleteSessionCommand;
}($Command));
export { DeleteSessionCommand };
//# sourceMappingURL=DeleteSessionCommand.js.map